import { render, staticRenderFns } from "./screen-dashboard.vue?vue&type=template&id=4192fb58"
import script from "./screen-dashboard.vue?vue&type=script&lang=js"
export * from "./screen-dashboard.vue?vue&type=script&lang=js"
import style0 from "./screen-dashboard.vue?vue&type=style&index=0&id=4192fb58&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports